module.exports = require('./lib/index');



/*****************
 ** WEBPACK FOOTER
 ** ./~/redux/~/symbol-observable/index.js
 ** module id = 207
 ** module chunks = 0
 **/